import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@klareospace/pharos-lib-web-utils';

import { useArchiveOrderType } from '../hooks';

// ─── Types ────────────────────────────────────────────────────────────────────

interface ArchiveOrderTypeDialogProps {
  onClose: () => void;
  orderTypeId: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ArchiveOrderTypeDialog({ onClose, orderTypeId }: ArchiveOrderTypeDialogProps): React.JSX.Element {
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('settings');
  const archiveOrderType = useArchiveOrderType();

  function handleConfirm(): void {
    if (archiveOrderType.isPending) return;
    archiveOrderType.mutate(orderTypeId, { onSettled: () => onClose() });
  }

  function handleOpenChange(open: boolean): void {
    if (!open) onClose();
  }

  return (
    <ConfirmDialog
      cancelLabel={tCommon('actions.cancel')}
      confirmLabel={tCommon('actions.archive')}
      description={t('orderTypes.actions.archive.dialog.description')}
      destructive
      isPending={archiveOrderType.isPending}
      onConfirm={handleConfirm}
      onOpenChange={handleOpenChange}
      open={!!orderTypeId}
      title={t('orderTypes.actions.archive.dialog.title')}
    />
  );
}
